module.exports = "<div layout layout-align=\"space-between center\" class=\"logout-button\"> <span class=\"logout-button__message\" ng-class=\"{'logout-button__message--small': $ctrl.smallWelcomeText}\"> Welcome back, {{$ctrl.nameText}}. </span> <button type=\"buton\" ng-click=\"$ctrl.onLogoutClicked()\" class=\"logout-button__message-2\"> Not you? Sign out </button> </div> ";


//////////////////
// WEBPACK FOOTER
// ./src/app/components/logoutButton/logoutButton.html
// module id = 856
// module chunks = 0